import { I18nProvider } from '@lingui/react';
import { Trans } from '@lingui/react/macro';
import { Spinner, Text, ToastContainer } from '@marketertechnologies/ui-library';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { Outlet, createRootRoute } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools';

import { i18n } from '~/utils/i18n';
import { queryClient } from '~/utils/queryClient';

const SupportLink = () => (
  <Text variant="body">
    <Trans>If the problem persists, please</Trans>{' '}
    <a
      href="https://intercom.help/marketer-real-estate-technologies/en"
      target="_blank"
      rel="noopener noreferrer"
      className="text-blue-500 underline hover:text-blue-700"
    >
      <Trans>contact support</Trans>
    </a>
    .
  </Text>
);

const RootLayout = () => {
  return (
    <I18nProvider i18n={i18n}>
      <QueryClientProvider client={queryClient}>
        <Outlet />
        <TanStackRouterDevtools />
        <ReactQueryDevtools initialIsOpen={false} client={queryClient} />
        <ToastContainer />
      </QueryClientProvider>
    </I18nProvider>
  );
};

export const Route = createRootRoute({
  wrapInSuspense: true,
  component: RootLayout,
  pendingComponent: () => (
    <div className="fixed grid h-full w-full place-items-center">
      <Spinner />
    </div>
  ),
  notFoundComponent: () => (
    <I18nProvider i18n={i18n}>
      <div className="fixed inset-2 grid h-full w-full place-items-center">
        <div className="flex flex-col gap-4">
          <Text variant="heading1">
            🚧 <Trans>Oops! Page Not Found</Trans>
          </Text>
          <div className="mt-4 flex flex-col">
            <Text variant="body">
              <Trans>Please check the URL and try again.</Trans>
            </Text>
            <SupportLink />
          </div>
        </div>
      </div>
    </I18nProvider>
  ),
  errorComponent: () => (
    <I18nProvider i18n={i18n}>
      <div className="fixed inset-2 grid h-full w-full place-items-center">
        <Text variant="heading2">
          <Trans>Something went wrong</Trans>
        </Text>
        <SupportLink />
      </div>
    </I18nProvider>
  ),
});
